import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { initSentry, Sentry } from '@/lib/sentry';
import './index.css';
// design/financy — the Financy layer, loaded after index.css and after the spotlight sheet below
// so its rules win at equal specificity. See src/financy.css for the idiom.
// IOSW-107 — the ported Pro Spotlight stylesheet, loaded HERE and not from the
// page, so its position in the bundle is deterministic: after Tailwind's
// preflight, never before it. Importing it from src/pages/Spotlight.tsx put it
// at byte 0 of the built CSS — ahead of the reset it has to survive — which is
// exactly the loading-order bug that made the IMAGE OS Markets map invisible
// for three deploys while every check stayed green.
import './spotlight-canvas.css';
import './financy.css';

import('@/lib/viewAs').then(m => m.adoptViewAsParam());
// HUB-025: answer a Designer window's sign-in renewal even after this tab reloaded (the broker checks the window's opener).
import('@/lib/designer-token-broker').then(m => m.listenForDesignerTokenRequests());
initSentry();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // staleTime: 0 lets refetchOnWindowFocus + refetchOnMount actually
      // fire. The old 60s staleTime meant tabbing back within a minute
      // (or navigating between pages) returned cached data — which made
      // the Spotlight flow look broken across iOS/Hub during 5/26 testing
      // (Pro saw stale draft_post, Owner missed Pro approval, etc.).
      // Realtime push via Supabase Realtime is the durable fix (WI-114);
      // until then, refetch-on-every-mount-and-focus keeps the UI honest.
      staleTime: 0,
      refetchOnWindowFocus: true, // re-pull when Pro returns to tab
      refetchOnMount: 'always',   // re-pull every navigation, not just first mount
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={
        <div className="min-h-screen bg-brand-fog grid place-items-center text-brand-slate text-sm">
          Something went wrong. Please refresh.
        </div>
      }
    >
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
